export enum UserType {
  ADMIN = 'ADMIN',
  DOCTOR = 'DOCTOR'
}
